import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./shloks.css"
function Shloks() {
    const [language, setLanguage] = useState("hindi");
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);
    const shloks = useMemo(() => [
        {
            id: 1,
            hindi: "कर्मण्येवाधिकारस्ते मा फलेषु कदाचन। मा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि॥",
            english: "Karmanye vadhikaraste ma phaleshu kadachana. Ma karmaphalaheturbhurma te sangostvakarmani.",
            meaningHindi: "मनुष्य को केवल अपने कर्म करने का अधिकार है, फल की चिंता नहीं करनी चाहिए।",
            meaningEnglish: "Focus on your actions and duties without worrying about the results.",
            source: "Bhagavad Gita 2.47"
        },
        {
            id: 2,
            hindi: "ॐ नमः शिवाय॥",
            english: "Om Namah Shivaya.",
            meaningHindi: "मैं भगवान शिव को नमन करता हूँ जो शांति और दिव्य शक्ति के स्वरूप हैं।",
            meaningEnglish: "I bow to Lord Shiva, the source of peace and divine energy.",
            source: "Shiva Mantra"
        },
        {
            id: 3,
            hindi: "हरे कृष्ण हरे कृष्ण कृष्ण कृष्ण हरे हरे। हरे राम हरे राम राम राम हरे हरे॥",
            english: "Hare Krishna Hare Krishna Krishna Krishna Hare Hare. Hare Rama Hare Rama Rama Rama Hare Hare.",
            meaningHindi: "यह महामंत्र मन को शुद्ध करता है और भगवान से जोड़ता है।",
            meaningEnglish: "This maha mantra purifies the soul and connects us with divine devotion.",
            source: "Maha Mantra"
        },
        {
            id: 4,
            hindi: "सर्वे भवन्तु सुखिनः सर्वे सन्तु निरामयाः। सर्वे भद्राणि पश्यन्तु मा कश्चिद्दुःखभाग्भवेत्॥",
            english: "Sarve Bhavantu Sukhinah Sarve Santu Niramayah.",
            meaningHindi: "सभी लोग सुखी, स्वस्थ और दुखों से मुक्त रहें।",
            meaningEnglish: "May all beings be happy, healthy, and free from suffering.",
            source: "Ancient Sanskrit Prayer"
        },
        {
            id: 5,
            hindi: "असतो मा सद्गमय। तमसो मा ज्योतिर्गमय। मृत्योर्मा अमृतं गमय॥",
            english: "Asato Ma Sadgamaya Tamaso Ma Jyotirgamaya.",
            meaningHindi: "हमें असत्य से सत्य की ओर, अंधकार से प्रकाश की ओर ले चलो।",
            meaningEnglish: "Lead us from untruth to truth and from darkness to light.",
            source: "Brihadaranyaka Upanishad"
        },
        {
            id: 6,
            hindi: "ॐ त्र्यम्बकं यजामहे सुगन्धिं पुष्टिवर्धनम्। उर्वारुकमिव बन्धनान्मृत्योर्मुक्षीय मामृतात्॥",
            english: "Om Tryambakam Yajamahe Sugandhim Pushtivardhanam.",
            meaningHindi: "हम भगवान शिव की उपासना करते हैं जो हमें स्वास्थ्य, शक्ति और मुक्ति प्रदान करते हैं।",
            meaningEnglish: "We worship Lord Shiva for health, strength, and liberation.",
            source: "Maha Mrityunjaya Mantra"
        },
        {
            id: 7,
            hindi: "गुरुर्ब्रह्मा गुरुर्विष्णुः गुरुर्देवो महेश्वरः। गुरुः साक्षात्परं ब्रह्म तस्मै श्रीगुरवे नमः॥",
            english: "Gurur Brahma Gurur Vishnu Gurur Devo Maheshwarah.",
            meaningHindi: "गुरु ही ब्रह्मा, विष्णु और महेश हैं। गुरु ही परम ब्रह्म हैं।",
            meaningEnglish: "The Guru is the embodiment of the divine trinity and supreme truth.",
            source: "Guru Mantra"
        },
        {
            id: 8,
            hindi: "वसुधैव कुटुम्बकम्॥",
            english: "Vasudhaiva Kutumbakam.",
            meaningHindi: "पूरा विश्व एक परिवार है।",
            meaningEnglish: "The entire world is one family.",
            source: "Maha Upanishad"
        },
        {
            id: 9,
            hindi: "ॐ गं गणपतये नमः॥",
            english: "Om Gam Ganapataye Namah.",
            meaningHindi: "भगवान गणेश को नमन जो सभी बाधाओं को दूर करते हैं।",
            meaningEnglish: "Salutations to Lord Ganesha, remover of all obstacles.",
            source: "Ganesh Mantra"
        },
        {
            id: 10,
            hindi: "लोकाः समस्ताः सुखिनो भवन्तु॥",
            english: "Lokah Samastah Sukhino Bhavantu.",
            meaningHindi: "सभी लोकों के प्राणी सुखी और शांतिपूर्ण रहें।",
            meaningEnglish: "May all beings everywhere live happily and peacefully.",
            source: "Vedic Prayer"
        }
    ], []);
    useEffect(() => {
        const track = document.getElementById("shlokTrack");
        if (!track) return;
        track.innerHTML = "";
        const repeatedShloks = [...shloks, ...shloks];
        repeatedShloks.forEach((item) => {
            const card = document.createElement("div");
            card.className = "shlok-card";
            card.innerHTML = `
                <div class="shlok-content">
                    <h3 class="shlok-hindi">
                        ${language === "hindi" ? item.hindi : item.english}
                    </h3>
                    <div class="meaning-box">
                        <p class="meaning-hindi">
                            ${language === "hindi"
                    ? item.meaningHindi
                    : item.meaningEnglish}
                        </p>
                        <p class="meaning-english">
                            ${language === "hindi"
                    ? item.meaningEnglish
                    : item.meaningHindi}
                        </p>
                    </div>
                    <span class="shlok-source">
                        ${item.source}
                    </span>
                </div>
            `;
            track.appendChild(card);
        });
    }, [language, shloks]);
    const toggleAudio = () => {
        setIsPlaying(!isPlaying);
    };
    return ( <>
        <section className="shloks-section animate-on-scroll">
            <div className="custom-container">
                <div className="section-title text-center">
                    <h2>Divine Spiritual Shloks</h2>
                    <p>
                        Read peaceful Hindu spiritual verses
                    </p>
                </div>
                {/* LANGUAGE SWITCH */}
                <div className="language-switch">
                    <button
                        className={language === "hindi" ? "active" : ""}
                        onClick={() => setLanguage("hindi")}
                    >
                        हिन्दी
                    </button>
                    <button
                        className={language === "english" ? "active" : ""}
                        onClick={() => setLanguage("english")}
                    >
                        English
                    </button>
                </div>
                {/* FLOATING MUSIC PLAYER */}
                {
                    isPlaying && (
                        /*  <iframe
                           width="0"
                           height="0"
                           src="https://www.youtube-nocookie.com/embed/1ZYbU82GVz4?autoplay=1&loop=1&playlist=1ZYbU82GVz4"
                           title="Divine Mantra Player"
                           frameBorder="0"
                           allow="autoplay"
                       ></iframe> */


                        <iframe
                            width="0"
                            height="0"
                            src="https://www.youtube-nocookie.com/embed/bc1obsjb58c?autoplay=1&loop=1&list=RDQo6eO50oxHc"
                            title="SHIVA | Beautiful Indian Background Music | Deep &amp; Mystical Meditation Music | Ambient Hindu Music"
                            frameBorder="0"
                            allow="autoplay">
                        </iframe>
                    )
                }
              
                {/* SHLOKS */}
                <div className="shlok-slider">
                    <div
                        className="shlok-track"
                        id="shlokTrack"
                    >
                    </div>
                </div>
            </div>
        </section>
          <div className={`floating-player`}>
                    <div className="player-left">
                        <div className="music-wave">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div className="player-info">
                            <h4>
                                Divine Mantra
                            </h4>
                            <p>
                                Spiritual Background Music
                            </p>
                        </div>
                    </div>
                    <button
                        className="player-btn"
                        onClick={toggleAudio}
                    >
                        {isPlaying ? "❚❚" : "▶"}
                    </button>
                </div>
        </>
    )
}
export default Shloks